export default [

     {
          path: '/data-catalog',
          name: 'DataCatalog',
          component: () => import("@/views/Page/DataCatalog/DataCatalog.vue"),
           meta: {
               title: '#Default# | DataCatalog',
          },
     }
];